enum ContractSigningTypes {
  Manually = 'Manually',
  DocuSign = 'DocuSign',
  SignFlow = 'SignFlow',
  Any = 'Any',
}

export { ContractSigningTypes };
export type VerifyContractSigningTypes = Utils.VerifyExtends<
  Model.Enum.ContractSigningTypes,
  Utils.ValueOf<typeof ContractSigningTypes>
>;
